export default {
  pageTitle: {
    en: "Sign in to your account",
    ja: "アカウントにサインインする"
  },

  buttonText: {
    en: "Sign in",
    ja: "ログイン"
  },
  cancel: {
    en: "Cancel",
    ja: "キャンセル"
  },
  forgotPassword: {
    en: "Forgot password?",
    ja: "パスワードをお忘れですか？"
  },
  signUp: {
    en: "Sign up",
    ja: "サインアップ"
  },

  Code: {
    en: "One time code",
    ja: "ワンタイムコード"
  },

  somethingWentWrong: {
    en: "Something went wrong",
    ja: "エラーが発生しました"
  },
  errorSignIn: {
    en: "Error signing in",
    ja: "サインイン エラー"
  },
  incorrectCredentials: {
    en: "Incorrect credentials",
    ja: "資格情報が正しくありません"
  },

  codeText: {
    en: "A message with a verification code has been sent to your email. Enter the code to continue.",
    ja: "確認コードが記載されたメッセージがメールに送信されました。 コードを入力して続行します。"
  },

  emailAddressLabel: {
    en: "Email",
    ja: "電子メールアドレス"
  },
  passwordLabel: {
    en: "Password",
    ja: "パスワード"
  },

  incorrectEmailWarning: {
    en: "Please enter a correct email",
    ja: "正しいメールアドレスを入力してください"
  },
  incorrectPasswordWarning: {
    en: "Password should be longer than 8 characters",
    ja: "パスワードは 8 文字以上にする必要があります"
  }
}
